import { render, staticRenderFns } from "./IconNetherlands.vue?vue&type=template&id=7ed06839&"
import script from "./IconNetherlands.vue?vue&type=script&lang=ts&"
export * from "./IconNetherlands.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports